import { Box } from "@mui/material";
import React from "react";
import { observer } from "mobx-react";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import AcxButton from "components/UI/AcxButton";
import {
    ClassifierBuilderV2Store,
    ClassifierBuilderView,
} from "../../Stores/ClassifierBuilderV2Store";

interface IRbcV2ConfirmationDialog {
    store: ClassifierBuilderV2Store;
}

export const ClassifierBuilderV2SwitchViewDialog = observer(
    ({ store }: IRbcV2ConfirmationDialog) => {
        const renderTitle = (): string => {
            let title =
                store.view === ClassifierBuilderView.Standard
                    ? "Switch to Advanced builder?"
                    : "Switch to Standard builder?";
            return title;
        };

        const renderText = (): string => {
            let text =
                store.view === ClassifierBuilderView.Standard
                    ? "The advanced editor lets you build more complex search queries, but requires expert knowledge of Full Text Search syntax. If you switch then you cannot return to the standard editor without losing your progress on this search. Proceed?"
                    : "Switching to the standard builder will overwrite all progress in the advanced editor. Proceed?";
            return text;
        };

        const renderButtonText = (): string => {
            let buttonText =
                store.view === ClassifierBuilderView.Standard
                    ? "Switch to Advanced"
                    : "Switch to Standard";
            return buttonText;
        };

        const onConfirmSwitchView = () => {
            store.toggleSwitchViewDialog();
            store.view === ClassifierBuilderView.Advanced &&
                (store.standardCBStore.classifierGroups = []);
            setTimeout(() => {
                store.toggleView();
            }, 200);
        };

        return (
            <AcxDialog
                title={renderTitle()}
                text={renderText()}
                isOpen={store.isSwitchViewDialogOpen}
                onClose={() => store.toggleSwitchViewDialog()}
                contentWidth="400px"
                children={
                    <Box>
                        <AcxButton
                            fullWidth
                            id="classifiers-v2-switch-button"
                            color="primary"
                            onClick={onConfirmSwitchView}
                        >
                            {renderButtonText()}
                        </AcxButton>
                    </Box>
                }
            />
        );
    },
);
